const __WEBPACK_NAMESPACE_OBJECT__ = require("i18n-react");